import { Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../../../store/app/app.selectors';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { helpCenterUrl } from '../../../_fixtures/project-fixtures';

@Component({
  selector: 'app-beta-registration-block-overlay',
  imports: [AsyncPipe, NgOptimizedImage],
  templateUrl: './beta-registration-block-overlay.component.html',
})
export class BetaRegistrationBlockOverlayComponent {
  readonly store = inject(Store);
  readonly shouldShow$ = this.store.select(AppSelectors.shouldShowBetaRegistrationOverlay);
  protected readonly helpCenterUrl = helpCenterUrl;
}
